import {
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import {
  type ContragentPayload,
  ContragentService,
} from "../../../../api/contragents"
import ContragentForm from "../../../../components/WMS/Contragents/ContragentForm"

export const Route = createFileRoute("/_layout/WMS/contragents/create")({
  component: CreateContragentPage,
})

function CreateContragentPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const contragentFormId = "contragent-create-form"

  const createMutation = useMutation({
    mutationFn: (payload: ContragentPayload) =>
      ContragentService.create(payload),
    onSuccess: async (created) => {
      toast({
        title: "Kontrahent został pomyślnie utworzony",
        status: "success",
      })
      await queryClient.invalidateQueries({ queryKey: ["contragents"] })
      navigate({
        to: "/WMS/contragents/$contragentId",
        params: { contragentId: created.id },
      })
    },
    onError: (error: any) => {
      toast({
        title: "Nie udało się utworzyć kontrahenta",
        description: error?.body?.error ?? error?.message ?? "Błąd",
        status: "error",
      })
    },
  })

  return (
    <Container maxW="10xl" py={6}>
      <Stack spacing={6}>
        <HStack justify="space-between" align="start" wrap="wrap" spacing={4}>
          <Box>
            <Heading size="lg">Dodaj kontrahenta</Heading>
            <Text color="gray.500" mt={2}>
              Formularz został przeniesiony na osobną stronę, żeby wygodniej
              uzupełniać większą liczbę danych.
            </Text>
          </Box>
          <HStack wrap="wrap">
            <Button
              size="sm"
              colorScheme="green"
              type="submit"
              form={contragentFormId}
              isLoading={createMutation.isPending}
            >
              Zapisz
            </Button>
            <Button
              size="sm"
              onClick={() =>
                navigate({
                  to: "/WMS/contragents/contragents-list",
                  search: {
                    q: "",
                    status: "",
                    page: 1,
                    page_size: 50,
                    sort_by: "full_name",
                    sort_dir: "asc",
                  },
                })
              }
            >
              Wróć
            </Button>
          </HStack>
        </HStack>

        <Box borderWidth="1px" borderRadius="xl" p={{ base: 4, md: 6 }}>
          <ContragentForm
            submitLabel="Zapisz"
            formId={contragentFormId}
            isPending={createMutation.isPending}
            onSubmit={(payload) => createMutation.mutate(payload)}
            showSubmitActions={false}
          />
        </Box>
      </Stack>
    </Container>
  )
}
